import { Box } from '@mui/material'
import { useGetLicenses } from 'hook/query/useGetLicense'
import Preloader from 'ui/Preloader'
import { CardLicense } from '../shared/card-license/CardLicense'

export const Licenses = () => {
	const { data, isLoading } = useGetLicenses()
	if (isLoading) {
		return <Preloader />
	}
	return (
		<Box
			sx={{
				height: '100%',
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(550px, 1fr))',
				gap: '30px',
				maxWidth: '100%',
			}}
		>
			{data.map(license => (
				<CardLicense key={license.license_num} license={license} />
			))}
		</Box>
	)
}
